import { Dialog } from "@headlessui/react";
import Close from "../../components/icons/Close";
import SmallStars from "../starRating/SmallStars";
import { AiOutlineSend } from "react-icons/ai";
import React, { useState, useEffect, useRef } from "react";
import Feedback from "./Feedback";
import Input from "../surveyForm/Input";
import { QRCodeCanvas } from "qrcode.react";

const isStandalone = process.env.REACT_APP_IS_STANDALONE === "true";

const VoucherDialog = ({
    setOverride,
    voucher,
    setVoucher,
    isVoucherOpen,
    setIsVoucherOpen,
    leat,
    voucherEmail,
    setVoucherEmail,
    onClickSubmit,
    voucherCode,
    translatedData
}) => {

    // QR code reference for download
    const qrRef = useRef(null);

    // download function
    const downloadQR = () => {
        const canvas = qrRef.current?.querySelector("canvas");
        if (!canvas) return;

        const pngUrl = canvas.toDataURL("image/png");

        const link = document.createElement("a");
        link.href = pngUrl;
        link.download = `voucher-${voucherCode}.png`;
        link.click();
    };

    if (!isStandalone) {
        return (
            <div className='tw1-absolute tw1-z-50 tw1-w-full tw1-top-[10px] tw1-left-1/2 tw1-transform tw1--translate-x-1/2'>
                <div className='tw1-z-50 tw1-flex tw1-items-center tw1-justify-center tw1-p-4 ' >
                    <div className='tw1-w-full tw1-rounded tw1-bg-white  tw1-max-w-[627px] tw1-rouded-[4px] tw1-relative tw1-max-h-full tw1-overflow-auto tw1-z-50'>
                        <div className='tw1-max-w-[548px] tw1-mx-auto tw1-py-12 tw1-px-6'>
                            <div className='tw1-text-xl tw1-font-medium tw1-mb-6 tw1-text-center tw1-text-[#374C51]'>
                                <div dangerouslySetInnerHTML={{ __html: leat?.details_text, }}></div>
                            </div>

                            {/* Email input */}
                            {!voucherCode ? <Input
                                type='text'
                                value={voucherEmail}
                                onChange={setVoucherEmail}
                                name='email'
                                label='Email:'
                                required={false}
                            />: null}

                            {/* submit button */}
                            {
                                !voucherCode ? (
                                    <div className='tw1-flex tw1-items-center tw1-flex-wrap tw1-justify-center tw1-flex-col' style={{ padding: '20px 0' }}>
                                        <button
                                            onClick={() => onClickSubmit()}
                                            type="submit"
                                            tabIndex={-1}
                                            className="font-semibold py-2 px-4 rounded voucher-claim-button"
                                        >
                                            {translatedData?.get_voucher}
                                        </button>
                                    </div>
                                ) : null
                            }

                            {/* QR Code + Download */}
                            {
                                voucherCode ? (
                                    <div className='tw1-flex tw1-items-center tw1-flex-wrap tw1-justify-center tw1-flex-col'>
                                        <div ref={qrRef}>
                                            <QRCodeCanvas value={voucherCode} size={128} />
                                        </div>
                                        <button onClick={downloadQR} className="tw1-mt-4 hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-gray-900 hover:border-transparent rounded">Download</button>
                                    </div>
                                ) : null
                            }

                            {/* Description */}
                            <div className='tw1-flex tw1-items-center tw1-flex-wrap tw1-justify-center tw1-flex-col'>
                                <div style={{ paddingTop: '15px', paddingBottom: '35px', textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: leat?.description_text, }}></div>
                            </div>
                        </div>

                        {/* Close button */}
                        <div
                            className='tw1-absolute tw1-top-4 tw1-right-4 tw1-cursor-pointer'
                            onClick={() => setIsVoucherOpen(false)}
                        >
                            <Close />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return voucher ? (
        <Dialog
            open={isVoucherOpen}
            onClose={() => { setVoucher(false); }}
            className='tw1-relative tw1-z-50'
        >
            <div className='tw1-fixed tw1-inset-0 tw1-flex tw1-items-center tw1-justify-center tw1-p-4 tw1-bg-gray-800 tw1-bg-opacity-50'>
                <Dialog.Panel className='tw1-w-full tw1-rounded tw1-bg-white tw1-max-w-[627px] tw1-rouded-[4px] tw1-relative tw1-max-h-full tw1-overflow-auto tw1-z-50'>
                    <div className='tw1-max-w-[548px] tw1-mx-auto tw1-py-12 tw1-px-6'>
                        <Dialog.Title className='tw1-text-xl tw1-font-medium tw1-mb-6 tw1-text-center tw1-text-[#374C51]'>
                            <div dangerouslySetInnerHTML={{ __html: leat?.details_text, }}></div>
                        </Dialog.Title>

                        {/* Email input */}
                        {!voucherCode ? <Input
                            type='text'
                            value={voucherEmail}
                            onChange={setVoucherEmail}
                            name='email'
                            label={translatedData?.email}
                            required={false}
                        />: null}

                        {/* submit button */}
                        {
                            !voucherCode ? (
                                <div className='tw1-flex tw1-items-center tw1-flex-wrap tw1-justify-center tw1-flex-col' style={{ padding: '20px 0' }}>
                                    <button
                                        onClick={() => onClickSubmit()}
                                        type="submit"
                                        tabIndex={-1}
                                        className="font-semibold py-2 px-4 rounded voucher-claim-button"
                                    >
                                        {translatedData?.get_voucher}
                                    </button>
                                </div>
                            ) : null
                        }

                        {/* QR Code + Download */}
                        {
                            voucherCode ? (
                                <div className='tw1-flex tw1-items-center tw1-flex-wrap tw1-justify-center tw1-flex-col'>
                                    <div ref={qrRef}>
                                        <QRCodeCanvas value={voucherCode} size={128} />
                                    </div>
                                    <button onClick={downloadQR} className="tw1-mt-4 hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-gray-900 hover:border-transparent rounded">Download</button>
                                </div>
                            ) : null
                        }

                        {/* Description */}
                        <div className='tw1-flex tw1-items-center tw1-flex-wrap tw1-justify-center tw1-flex-col'>
                            <div style={{ paddingTop: '15px', paddingBottom: '35px', textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: leat?.description_text, }}></div>
                        </div>
                    </div>

                    {/* Close button */}
                    <div
                        className='tw1-absolute tw1-top-4 tw1-right-4 tw1-cursor-pointer'
                        onClick={() => setIsVoucherOpen(false)}
                    >
                        <Close />
                    </div>
                </Dialog.Panel>
            </div>
        </Dialog>
    ) : null;
};

export default VoucherDialog;
